export const styles = {
  card: { padding: '2.5rem', marginBottom: '2rem', marginTop: '2rem' },
  buttonsWrapper: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 30,
  },
  title: {
    marginTop: '1rem',
    marginBottom: '2rem',
  },
  row: {
    marginBottom: '2rem',
  },
}
